import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("DOCUMENTS ENTREPRISE LOAD")
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });


      $("#filterrific_nom_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".nom_hide").show();
        } else {
          $(".nom_hide").hide();
        }
      });

      $("#filterrific_version_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".version_hide").show();
        } else {
          $(".version_hide").hide();
        }
      });

      $("#filterrific_commentaires_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".commentaires_hide").show();
        } else {
          $(".commentaires_hide").hide();
        }
      });

      $("#filterrific_created_at_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".created_at_hide").show();
        } else {
          $(".created_at_hide").hide();
        }
      });

      $("#filterrific_updated_at_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".updated_at_hide").show();
        } else {
          $(".updated_at_hide").hide();
        }
      });

      this.handleSidebarScroll("entreprises_document_");

    }
  }

  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A"),
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }


  get current_app() {
    return this.data.get("app");
  }
  get note_de_frai_id() {
    return this.data.get("note_de_fraiid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}




// HM
// - frais

// Colonnes fixes sur le mode liste
// - N°
// - Collaborateur
// - Statut
// - Réglée (o/n)
// - Ajouter
// - Dépenses

// Colonnes qu'on peut ajouter
// - Année ==>
// - Mois==>
// - Entité 
// - Virement immédiat
// - Devise de l'entité
// - Total HT (devise entité)
// - Total TVA (devise entité)
// - Total TTC (devise entité)
// - Total HT refacturable (devise entité)
// - Total à rembourser (devise entité)
// - Total HT (devise groupe)
// - Total TVA (devise groupe)
// - Total TTC (devise groupe)
// - Total à rembourser (devise groupe)
// - Créé le
// - Créé par
// - Soumis le
// - Soumis par
// - Validé le
// - Validé par